// extracted by mini-css-extract-plugin
export default {"input":"forgot-password_input__OCEeT","submit-button":"forgot-password_submit-button__V0yzN"};